import React from 'react';
import PropTypes from 'prop-types';
import PropertyListItem from './components/PropertyListItem';
import { Row, Card, Col } from 'react-bootstrap';
import classNames from 'classnames';
import ButtonEdit from 'utils/buttons/ButtonEdit';

export const skeletonObj = {
  id: 1,
  status: 'asd',
  title: 'Texto de propiedad',
  address: `Texto para la dirección`,
  barrios: 'Texto para el barrio',
  price: '3123',
  expenses: 'Texto para las expensas',
  operation: `Operacion`,
  updated_at: 'Texto para la fecha',
  created_at: 'Texto para la fecha',
  type: 'Texto para el tipo',
  locality: 'Texto para la localidad',
  characteristics: {
    ambience: 10,
    bedrooms: 10,
    bathrooms: 10,
    toilettes: 10,
    garages: 10,
    floors: 10
  },
  surface: {
    totalSurface: 10,
    coveredSurface: 10
  },
  share: 50,
  real_estate: {
    name: 'Texto para la inmobiliaria',
    branchOffice: [
      {
        id: 1,
        branch_office_name: 'Texto para Sucursal',
        isCentral: false,
        isActive: true,
        phoneNumber: '1234567890',
        openingHours: 'Texto para el horario',
        address: 'Texto para la dirección'
      }
    ]
  },
  actions: [<ButtonEdit key="skeleton-button" funcion={() => {}} />]
};

const PropsCards = ({
  properties,
  length,
  loading,
  propsLimit,
  selected,
  setSelected
}) => {
  const skeletonArr = Array(propsLimit).fill(skeletonObj);

  return (
    <Row
      className={classNames('g-2', {
        'loading-skeleton': loading
      })}
    >
      {!loading ? (
        length > 0 ? (
          properties.map(property => (
            <PropertyListItem
              key={property.id}
              property={property}
              selected={selected}
              setSelected={setSelected}
            />
          ))
        ) : (
          <Col xs={12}>
            <Card
              className="bg-white"
              style={{
                borderLeft: `5px solid var(--falcon-lighten-secondary)`
              }}
            >
              <Card.Body>
                <Col xs={12} className="d-flex">
                  <Row>
                    <Col xs={12}>
                      <h5 className="d-block fw-bold m-0">
                        Sin propiedades para mostrar.
                      </h5>
                    </Col>
                  </Row>
                </Col>
              </Card.Body>
            </Card>
          </Col>
        )
      ) : (
        skeletonArr.map((property, index) => (
          <PropertyListItem key={index} property={property} loading />
        ))
      )}
    </Row>
  );
};

PropsCards.propTypes = {
  properties: PropTypes.array,
  length: PropTypes.number,
  loading: PropTypes.bool,
  propsLimit: PropTypes.number.isRequired,
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired
};

export default PropsCards;
